import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'

import starter from './starter'
import blog from './blog'
import offices from './offices'


export default combineReducers({
  starter,
  blog,
  offices,
  routerReducer
})
